import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CricketScorecardV2 from 'components_v2/common/CricketScoreCardV2';
import { loadLiveblogCricketScorecardData } from './redux';

class WithCricketScorecardV2 extends React.Component {
  loadCricketScoreCardData = () => {
    this.props.loadData(this.props.params);
  };

  refreshTimer = null;

  render() {
    const { data } = this.props;

    // auto refresh mini scorecard
    if (
      data &&
      data.matchStatus !== 'Match Ended' &&
      !this.refreshTimer &&
      this.props.autoRefreshRate
    ) {
      this.refreshTimer = setInterval(
        this.loadCricketScoreCardData,
        parseInt(this.props.autoRefreshRate, 10),
      );
    }

    // stop timer after match end
    if (data && data.matchStatus === 'Match Ended' && this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }

    return (
      <CricketScorecardV2
        loadDataFn={this.loadCricketScoreCardData}
        data={data}
        params={this.props.params}
        wrapperClass={this.props.wrapperClass}
      />
    );
  }
}

const mapStateToProps = state => ({
  data: state.cricketScorecard.data,
});

const mapDispatchToProps = dispatch => ({
  loadData: params => {
    dispatch(loadLiveblogCricketScorecardData(params));
  },
});

WithCricketScorecardV2.propTypes = {
  loadData: PropTypes.func.isRequired,
  params: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({}),
  autoRefreshRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

WithCricketScorecardV2.defaultProps = {
  data: undefined,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  WithCricketScorecardV2,
);
